// extracted by mini-css-extract-plugin
export default {"bottomNavigationMenu":"BottomNavigation_bottomNavigationMenu__V594u"};